/*
 * @Author: Zhang Hang
 * @Date: 2019-12-17 17:24:09
 * @Description: 快音桥接方法定义
 */
import { getRmKReferrerHref } from './common';
import platform from './platform';
// iOS 桥接方法使用第三方框架 DSBridge（ https://github.com/wendux/DSBridge-IOS ）
const dsBridge = require('dsbridge');

const getUrlParamsNotDecode = (name, url) => {
	if (!url) url = window.location.href;
	name = name.replace(/[\[\]]/g, '\\$&'); // eslint-disable-line
	const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
	const results = regex.exec(url);
	if (!results) return null;
	if (!results[2]) return '';
	return results[2];
};

// ========================================= 客户端调用H5方法, H5执行的回调函数的列表 =========================================

let onShowCallbacks = [];
let onHideCallbacks = [];
let onRewardVideoPlayEndCallbacks = [];
let onMuscicActionCallbacks = [];
let onAcceptCoinCallbacks = [];
let onCloseFeedAdCallbacks = [];
let onShowTuiaCustomCallbacks = [];
let onOneKeyLoginCallbacks = [];
let onBindWeChatAccountCallbacks = [];
let onFeedBtnClickCallbacks = [];
let onFeedSubBtnClickCallbacks = [];
let onCalendarCallBacks = [];
let onUploadSuccessCallBacks = [];

// ========================================= 客户端调用H5方法, H5执行的回调函数的列表 =========================================

// ==================================================== 初始化 H5 方法 =======================================================

// let methodListInited = false; // H5 定义的方法是否在客户端初始化的变量

let _initMethodList = () => {
	// setMethod 在 sdkNew 中初始化
	/* if (window.bridge && !methodListInited) {
		methodListInited = true;
		window.bridge.setMethodList(
			'["onShow", "onHidden", "onRewardVideoPlayEnd", "onMuscicAction", "onAcceptCoin", "onCloseFeedAd", "onShowTuiaCustom", "onOneKeyLogin", "onBindWeChatAccount", "onFeedBtnClick", "onFeedSubBtnClick", "onUploadSuccess","onCalendarCallBack", "onRewardVideoPlayFailed", "onRewardVideoJump"]'
		);
	} */
};

if (window.bridge) {
	window.bridge.onShow = function () {
		onShowCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onHidden = function () {
		onHideCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onRewardVideoPlayEnd = function () {
		onRewardVideoPlayEndCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onAcceptCoin = function () {
		onAcceptCoinCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onMusicAction = function (response, page_title) {
		let res = JSON.parse(response);
		let pt = page_title;
		onMuscicActionCallbacks.map((fun) => {
			try {
				fun(res, pt);
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onCloseFeedAd = function () {
		onCloseFeedAdCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onFeedBtnClick = function () {
		onFeedBtnClickCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onFeedSubBtnClick = function () {
		onFeedSubBtnClickCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onCalendarCallBack = function (response) {
		const res = JSON.parse(response);
		onCalendarCallBacks.map((fun) => {
			try {
				fun(res);
			} catch (e) {
				console.log(e);
			}
		});
	};

	window.bridge.onShowTuiaCustom = function (response) {
		const resObj = JSON.parse(response);
		const reportExposureUrl = resObj.reportExposureUrl;
		const reportClickUrl = resObj.reportClickUrl;

		let reportExposureUrl_md = getUrlParamsNotDecode('md', reportExposureUrl);
		let reportClickUrl_md = getUrlParamsNotDecode('md', reportClickUrl);

		let reportExposureUrl_md_encode = encodeURIComponent(reportExposureUrl_md);
		let reportClickUrl_md_encode = encodeURIComponent(reportClickUrl_md);

		let rp_ExposureUrl = reportExposureUrl.replace(reportExposureUrl_md, reportExposureUrl_md_encode);
		let rp_ClickUrl = reportClickUrl.replace(reportClickUrl_md, reportClickUrl_md_encode);

		Object.assign(resObj, {
			reportExposureUrl: rp_ExposureUrl,
		});
		Object.assign(resObj, {
			reportClickUrl: rp_ClickUrl,
		});

		onShowTuiaCustomCallbacks.map((fun) => {
			try {
				fun(resObj);
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onOneKeyLogin = function (response) {
		const res = JSON.parse(response);
		onOneKeyLoginCallbacks.map((fun) => {
			try {
				fun(res);
			} catch (e) {
				console.log(e);
			}
		});
	};
	window.bridge.onBindWeChatAccount = function () {
		onBindWeChatAccountCallbacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};

	/**
	 * @description: 投稿上传成功回调
	 */

	window.bridge.onUploadSuccess = function () {
		onUploadSuccessCallBacks.map((fun) => {
			try {
				fun();
			} catch (e) {
				console.log(e);
			}
		});
	};
}

// ========================================= 初始化 H5 方法 =========================================

// ========================================= 导出客户端的方法供 H5 端调用  =========================================
export default {
	/**
	 * @description: 打开一个 Webview, 如果以不是 kuaiyin:// 协议开头的链接，需要拼接 k_referrer 方便神策追踪前置链接
	 * @param: {type} url
	 * @return:
	 */

	openPage(url) {
		if (!/^kuaiyin/.test(url)) {
			url += `${/\?/.test(url) ? '&' : '?'}k_referrer=${decodeURIComponent(
				getRmKReferrerHref(window.location.pathname + window.location.search)
			)}`;
		}
		if (window.bridge) {
			window.bridge.openPage(url);
		} else {
			window.location.href = url;
		}
	},

	/**
	 * @description: 打开一个 Webview，与 openPage 的区别在于可以携带与客户端协商的自定义参数
	 * @param: {type} JSONstr， 需要传入一个 JSON 字符串
	 * @return:
	 */

	async openPageWithJSON(JSONstr) {
		// await checkAnnounceStatus(JSONstr);
		let json = JSON.parse(JSONstr);
		let needAddKReferrer =
			!/^kuaiyin/.test(json.url) &&
			!/^mqqopensdkapi/.test(json.url) &&
			json.url.search('ads66') === -1 &&
			json.url.search('yuemeng') === -1 &&
			!/^mgcgame/.test(json.url) &&
			json.url.search('m.playmy.cn') === -1;

		if (needAddKReferrer) {
			json.url += `${/\?/.test(json.url) ? '&' : '?'}k_referrer=${decodeURIComponent(
				getRmKReferrerHref(window.location.pathname + window.location.search)
			)}`;
		}
		console.log('openPageWithJSON', json.url);

		let jStr = JSON.stringify(json);

		if (window.bridge) {
			if (window.bridge.openPageWithJSON) {
				window.bridge.openPageWithJSON(jStr);
			} else {
				window.bridge.openPage(json.url);
			}
		} else if (window.dsBridge) {
			dsBridge.call('openPageWithJSON', jStr);
		} else {
			window.location.href = json.url;
		}
	},
	/**
	 * @description: 打开快音小游戏的方法
	 * @param: {type} { url: 快音小游戏的链接 }
	 * @return:
	 */

	async openTipAdGame(JSONstr) {
		// await checkAnnounceStatus(JSONstr);
		let json = JSON.parse(JSONstr);
		let { url } = json;
		if (!/^kuaiyin/.test(url)) {
			url += `${/\?/.test(url) ? '&' : '?'}k_referrer=${decodeURIComponent(
				getRmKReferrerHref(window.location.pathname + window.location.search)
			)}`;
		}

		console.log('openTipAdGame', url);

		if (window.bridge) {
			window.bridge.openTipAdGame(url);
		} else {
			window.location.href = url;
		}
	},
	/**
	 * @description: 调用客户端的 Toast
	 * @param:
	 * @return:
	 */

	toastText(txt) {
		if (platform.platform === 'ios') {
			dsBridge.call('toast', txt);
		}
		if (window.bridge) {
			window.bridge.toast(txt);
		}
	},
	/**
	 * @description: 调用客户端的复制功能
	 * @param:
	 * @return:
	 */

	copy(str) {
		if (platform.platform === 'ios') {
			dsBridge.call('copy', str);
		}
		if (window.bridge) {
			window.bridge.copy(str);
		}
	},
	/**
	 * @description: 调用客户端的分享功能，分为 shareTo 和 openShare 方法
	 * @param:
	 * @return:
	 */

	openShare(shareInfo) {
		/**
		 * eg:
		 * {
		 *    "platform":"weixin",
		 *    "title":"我在【快音】听音乐，让我们一起嗨起来吧！",
		 *    "desc":"点击进入填我邀请码领新人红包",
		 *    "thumb":"http://static1.kaixinyf.cn/img/cus5db6877043805813924925.png",
		 *    "url":"http://h5.rd.kaixinyf.cn/share?invite_code=PP2GTU&_timestamp=1576574939&sign=a56ed9d28e453cbd6bf973bfb6460673&share_from=weixin"
		 * }
		 */
		// console.log('shareInfo', JSON.stringify(shareInfo));

		if (platform.platform === 'ios') {
			dsBridge.call('shareInfo', shareInfo);
		}

		if (window.bridge) {
			window.bridge.shareTo(JSON.stringify(shareInfo));
		}
	},
	/**
	 * @description: 设置页面标题
	 * @param:
	 * @return:
	 */

	setTitle(tit) {
		if (platform.platform === 'ios') {
			try {
				dsBridge.call('setTitle', tit);
			} catch (e) {
				console.log(e);
				window.document.title = tit;
			}
		}

		if (window.bridge) {
			try {
				window.bridge.setTitle(tit);
			} catch (e) {
				console.log(e);
			}
		} else {
			window.document.title = tit;
		}
	},
	/**
	 * @description: 关闭 Webview
	 * @param:
	 * @return:
	 */

	closeWebView() {
		if (platform.platform === 'ios') {
			try {
				dsBridge.call('closeWebView');
			} catch (e) {
				console.log(e);
			}
		}
		if (window.bridge) {
			try {
				console.log('window.bridge.closeWebView', window.bridge.closeWebView);
				window.bridge.closeWebView();
			} catch (e) {
				console.log(e);
			}
		}
	},
	/**
	 * @description: 接入多游游戏，获取本机 IMEI 的方法
	 * @param:
	 * @return:
	 */

	getDyIMEI() {
		if (window.dysdk) {
			let imei;
			if (window.dysdk.getIMEIV2) {
				imei = window.dysdk.getIMEIV2(); // 2.4.0 之后接入
			} else {
				imei = window.dysdk.getIMEI();
			}
			return imei;
		}
	},
	/**
	 * @description: 接入多游游戏，获取本机 OAID 的方法。2.4.0 之后接入
	 * @param:
	 * @return:
	 */

	getDyOAID() {
		if (window.dysdk) {
			let oaid = window.dysdk.getOAIDV2();
			return oaid;
		}
	},
	/**
	 * @description: 接入蛋蛋游戏，获取本机 IMEI 的方法，2.4.0 之后接入
	 * @param:
	 * @return:
	 */

	getDdIMEI() {
		if (window.android) {
			let imei = window.android.getIMEIV2();
			return imei;
		}
		// return '866697022020503';
	},
	/**
	 * @description: 获取AndroidID
	 * @param:
	 * @return:
	 */

	getAndroidID() {
		if (window.android) {
			let androidID = window.android.getAndroidIdV2();
			return androidID;
		}
		// return '4c21657a-620e-44ca-bfc7-f36a332707ea';
	},
	/**
	 * @description: 接入蛋蛋游戏，获取本机 OAID 的方法，2.4.0 之后接入
	 * @param:
	 * @return:
	 */

	getDdOAID() {
		if (window.android) {
			let oaid = window.android.getOAIDV2();
			return oaid;
		}
		// return '4c21657a-620e-44ca-bfc7-f36a332707ea';
	},
	/**
	 * @description:
	 * @param {type}
	 * @return:
	 */

	callCalendar(jsonStr) {
		if (window.bridge && window.bridge.handleCalendar) {
			window.bridge.handleCalendar(jsonStr);
		} else {
			dsBridge.call('callCalendar', jsonStr);
		}
	},
	/**
	 * @description: 从客户端获取用户信息，发布时必须注释掉 obj 中的内容， 本地开发时需取消 obj 对象的注释。
	 * @param:
	 * @return: Object
	 */

	getUserInfo() {
		const {
			location: { pathname },
		} = window;
		const inValidPathName = ['/privacy_protocol', '/agreement', '/third-sdk-list'];

		if (inValidPathName.includes(pathname)) {
			console.log(`inValidPathName`);
			return {
				platform: '',
				client_v: '',
				sa_device_id: '',
				device_id: '',
			};
		}

		let obj = {
			// nickname: 'Harvey Chang',
			// city: '朝阳',
			// avatar: 'http://static1.kaixinyf.cn/img/lza611f8851948b4553036857.jpeg?x-oss-process\u003dimage/resize,m_fixed,h_128,w_128',
			// 'client-v': '5.05.00',
			// refreshToken:
			// 	'eyJleHAiOjE2MzY2ODEwMzcsImFsZyI6IkhTMjU2In0.eyJ1aWQiOiI1MDE3ODgwIiwib3BlbmlkIjoib1liVkx4SkQzM1BwOUN5WDdVR25RdDJ1TDR3cyIsImV4cCI6MTYzNjY4MTAzN30.zjiI1nnzqw01hiGp4X_-Z3r_1WsNHgASWHayCH76Z6k',
			// accessToken:
			// 	'eyJleHAiOjE2Mzc2NzA3NjksImtpZCI6NywiYWxnIjoiSFMyNTYifQ.eyJ1aWQiOiI1MTIwMDAxIiwib3BlbmlkIjoiIiwiZXhwIjoxNjM3NjcwNzY5fQ.ey73n1l5Kh2hUxa4NP3Dj_-dhTkyywlFdDV5WareIfc',
			// gender: '男',
			// 'platform-v': '6.0',
			// 'utm-source': 'dev',
			// oaid: '',
			// platform: 'Android',
			// registerTime: '1613799502',
			// osversion: '23',
			// 'device-id': 'd6d6cefbd1d9d861',
			// age: '23',
			// vipEntrance: '0',
			// imei: '866697022020503',
			// tourist_token: '',
			// sa_device_id: 'd6d6cefbd1d9d861',
			// uid: '5017880',
			// 'platform-brand': 'HUAWEI',
			// 'platform-model': 'HUAWEI GRA-UL10',
			// 'app-v': '5.05.00',
		};

		if (platform.platform === 'ios') {
			if (dsBridge) {
				let info = dsBridge.call('getUserInfo');
				try {
					Object.assign(obj, JSON.parse(info));
				} catch (e) {
					// console.log(e);
				}
			}
		} else if (platform.platform === 'android') {
			if (window.bridge) {
				let info = window.bridge.getUserInfo();
				try {
					Object.assign(obj, JSON.parse(info));
				} catch (e) {
					console.log(e);
				}
			}
		}
		// console.log('obj', obj);
		return obj;
	},
	/**
	 * @description: 预加载激励视频
	 * @param {type} 需要传入两个 JSON 字符串, 主视频任务和补偿视频任务
	 * @return:
	 */

	preLoadAds(masterVideoJSONstr, fillVideoJSONstr) {
		console.log('preLoadAds-masterVideoJSONstr', masterVideoJSONstr);
		console.log('preLoadAds-fillVideoJSONstr', fillVideoJSONstr);
		if (window.bridge) {
			if (fillVideoJSONstr) {
				window.bridge.preLoadAds(masterVideoJSONstr, fillVideoJSONstr);
			} else {
				window.bridge.preLoadAds(masterVideoJSONstr);
			}
		}
	},
	/**
	 * @description: 打开激励视频的方法
	 * @param {type} 需要传入两个 JSON 字符串, 主视频任务和补偿视频任务
	 * @return:
	 */

	showRewardVideo(masterVideoJSONstr, fillVideoJSONstr) {
		console.log('showRewardVideo-masterVideoJSONstr', masterVideoJSONstr);
		console.log('showRewardVideo-fillVideoJSONstr', fillVideoJSONstr);
		let json = JSON.parse(masterVideoJSONstr);

		if (platform.platform == 'ios') {
			if (dsBridge) {
				let JSONObj = {};
				if (fillVideoJSONstr) {
					JSONObj = {
						master: JSON.parse(masterVideoJSONstr),
						fill: JSON.parse(fillVideoJSONstr),
					};
				} else {
					JSONObj = {
						master: JSON.parse(masterVideoJSONstr),
					};
				}
				dsBridge.call('showRewardVideoAdWithJSON', JSONObj);
			}
		} else if (platform.platform === 'android') {
			if (window.bridge) {
				if (window.bridge.showRewardVideoAdWithJSON) {
					if (fillVideoJSONstr) {
						try {
							window.bridge.showRewardVideoAdWithJSON(masterVideoJSONstr, fillVideoJSONstr);
						} catch (e) {
							console.log(e);
						}
					} else {
						try {
							window.bridge.showRewardVideoAdWithJSON(masterVideoJSONstr);
						} catch (e) {
							console.log(e);
						}
					}
				} else {
					try {
						window.bridge.showRewardVideoAd(json.task_type_id, json.task_record_id);
					} catch (e) {
						console.log(e);
					}
				}
			}
		}
	},
	/**
	 * @description: 加载音乐列表。此方法用于给客户端音乐播放器加载音乐列表
	 * @param {type} 需要传入一个 JSON 字符串
	 * @return:
	 */

	initMusicPlayerList(JSONstr, page_title) {
		if (platform.platform === 'ios') {
			let data = JSON.parse(JSONstr);
			data.page_title = page_title;
			console.log(`setMusicList data`, data);
			dsBridge.call('setMusicList', JSON.stringify(data));
		}

		if (window.bridge) {
			window.bridge.initMusicList(JSONstr, page_title);
		}
	},
	/**
	 * @description: 插入音乐列表。此方法用于给客户端音乐播放器插入音乐列表数据
	 * @param {type} 需要传入一个 JSON 字符串
	 * @return:
	 */

	appendMusicPlayerList(JSONstr, page_title) {
		if (platform.platform === 'ios') {
			let data = JSON.parse(JSONstr);
			data.page_title = page_title;
			dsBridge.call('appendMusicList', JSON.stringify(data));
		}

		if (window.bridge) {
			window.bridge.appendMusicList(JSONstr, page_title);
		}
	},
	/**
	 * @description: 播放音乐
	 * @param {type} 需要传入一个 int 类型的 index, String action
	 * @return:
	 */

	handleMusicByAction(index, action, page_title) {
		if (platform.platform === 'ios') {
			let JSONData = {
				index,
				action,
				page_title,
			};
			dsBridge.call('h5MusicAction', JSON.stringify(JSONData));
		}
		if (window.bridge) {
			window.bridge.h5MusicAction(index, action, page_title);
		}
	},
	/**
	 * @description: 投稿
	 * @param {type} 需要传 String 的话题
	 * @return:
	 */

	postMusicWork(JSONstr) {
		console.log(platform.platform, 'platform.platform --');
		console.log(JSONstr);

		if (platform.platform === 'ios') {
			dsBridge.call('uploadOpus', JSONstr);
		}
		if (window.bridge) {
			window.bridge.uploadOpus(JSONstr);
		}
	},
	/**
	 * @description: 显示插屏页广告
	 * @param {type} 需要传 String 的金币数量
	 * @return:
	 */

	showFeedAd(coin, todayCoin, adId) {
		if (window.bridge) {
			window.bridge.showFeedAd(String(coin), String(todayCoin), String(adId));
			console.log('showFeedAd()');
		}
	},
	/**
	 * @description: 显示插屏页广告
	 * @param {type} 需要传 String 的金币数量
	 * @return:
	 */

	showFeedADV2(JSONstr) {
		if (window.bridge) {
			window.bridge.showFeedADV2(JSONstr);
			console.log('showFeedADV2()');
		}
	},
	/**
	 * @description: 预加载插屏页广告
	 * @param {type} 需要传 String 的金币数量
	 * @return:
	 */

	preLoadTTFeedAd(adId) {
		if (window.bridge) {
			if (window.bridge.preLoadTTFeedAd) {
				window.bridge.preLoadTTFeedAd(String(adId));
			}
		}
	},

	getTuiCustomAd(adId, userId) {
		if (window.bridge) {
			if (window.bridge.showTuiCustomAd) {
				window.bridge.showTuiCustomAd(adId, String(userId));
			}
		}
	},

	getTuiInterstitialAd(uid, adId) {
		if (window.bridge) {
			window.bridge.showTuiInterstitialAd(uid, adId);
		}
	},
	/**
	 * @description: 一键登录-预登录
	 * @param {type}
	 * @return:
	 */

	oneKeyPreLogin() {
		if (window.bridge && window.bridge.oneKeyPreLogin) {
			window.bridge.oneKeyPreLogin();
		}
	},
	/**
	 * @description: 一键登录
	 * @param {type}
	 * @return:
	 */

	oneKeyLogin() {
		if (window.bridge && window.bridge.oneKeyLogin) {
			window.bridge.oneKeyLogin();
		}
	},
	/**
	 * @description: 调起原生绑定微信页面
	 * @param {type}
	 * @return:
	 */

	bindWeChatAccount() {
		if (platform.platform === 'ios') {
			try {
				dsBridge.call('bindWeChatAccount');
			} catch (e) {
				console.log(e);
			}
		}
		if (window.bridge && window.bridge.bindWeChatAccount) {
			window.bridge.bindWeChatAccount();
		}
	},
	/**
	 * @description: 发送事件
	 * @param {type}
	 * @return:
	 */

	postEvent(event) {
		if (window.bridge && window.bridge.onEvent) {
			window.bridge.onEvent(event);
		}
	},
	/**
	 * @description: 变现猫桥接方法
	 * @param {type}
	 * @return:
	 */

	openBxmGame(id) {
		if (window.bridge && window.bridge.openBxmGameDialog) {
			window.bridge.openBxmGameDialog(String(id));
		}
	},
	/**
	 * @description: 检查日历是否授权的方法
	 * @param {type}
	 * @return:
	 */

	checkCalendarState() {
		if (window.bridge && window.bridge.isCalendarEnabled) {
			const res = window.bridge.isCalendarEnabled();
			return res;
		} else {
			let res = dsBridge.call('isCalendarEnabled');
			res = +res === 0 ? false : true;
			return res;
		}
	},
	/**
	 * @description: 检查通知栏的方法
	 * @param {type}
	 * @return:
	 */

	async checkNotificationState(channelId) {
		if (window.bridge && window.bridge.isNotificationEnabled) {
			try {
				let res = null;
				if (channelId) {
					res = await window.bridge.isNotificationEnabled(channelId);
				} else {
					res = await window.bridge.isNotificationEnabled(channelId);
				}
				return res;
			} catch (e) {
				console.log(e);
			}
		} else {
			const res = await dsBridge.call('isNotificationEnabled');
			return res;
		}
	},
	/**
	 * @description: 打开通知设置界面
	 * @param {type}
	 * @return:
	 */

	openNotification(openId, channelId) {
		if (window.bridge && window.bridge.openNotification) {
			if (channelId) {
				window.bridge.openNotification(openId, channelId);
			} else {
				window.bridge.openNotification(openId);
			}
		} else {
			dsBridge.call('openNotification', openId);
		}
	},
	/*
	 * @description: 打开谷雨小说
	 * @param {type}
	 * @return:
	 */

	async openGuYuNovel(JSONstr) {
		// await checkAnnounceStatus(JSONstr);
		if (window.bridge && window.bridge.openNovel) {
			window.bridge.openNovel();
		}
	},
	/**
	 * @description: 页面切换到前台显示，客户端会调用此方法。H5 端一般用于加载页面方法
	 * @param {type}
	 * @return:
	 */

	addOnShowEvent(fun) {
		_initMethodList();
		onShowCallbacks = [];
		onShowCallbacks.push(fun);

		if (platform.platform == 'ios') {
			// Register javascript API for Native
			dsBridge.register('onShow', function () {
				onShowCallbacks.map((fun) => {
					try {
						fun();
					} catch (e) {
						console.log(e);
					}
				});
			});
		}
	},

	/**
	 * @description: 页面切换到后台，客户端会调用此方法。
	 * @param {type}
	 * @return:
	 */

	addOnHideEvent(fun) {
		_initMethodList();
		onHideCallbacks.push(fun);
	},

	/**
	 * @description: 激励视频观看结束，客户端会调用此方法。
	 * @param {type}
	 * @return:
	 */

	addRewardVideoPlayEndEvent(fun) {
		_initMethodList();
		// 每次 create 的生命周期时，清空积累的回调函数。避免重复叠加后多次触发累积的函数
		onRewardVideoPlayEndCallbacks = [];
		onRewardVideoPlayEndCallbacks.push(fun);
		if (platform.platform == 'ios') {
			dsBridge.register('onRewardVideoPlayEnd', function () {
				console.log('onRewardVideoPlayEnd');
				onRewardVideoPlayEndCallbacks.map((fun) => {
					try {
						fun();
					} catch (e) {
						console.log(e);
					}
				});
			});
		}
	},
	/**
	 * @description: 打开插屏广告的收下金币，客户端会调用此方法。
	 * @param {type}
	 * @return:
	 */

	addAcceptCoinEvent(fun) {
		_initMethodList();
		onAcceptCoinCallbacks.push(fun);
	},

	/**
	 * @description: 音乐下载结束，客户端会调用此方法。
	 * @param {type}
	 * @return:
	 */

	addMusicActionEvent(fun) {
		_initMethodList();
		onMuscicActionCallbacks.push(fun);
		if (platform.platform == 'ios') {
			dsBridge.register('onMusicAction', function (response, page_title) {
				// let res = JSON.parse(response);
				let pt = page_title;
				onMuscicActionCallbacks.map((fun) => {
					try {
						fun(response, pt);
					} catch (e) {
						console.log(e);
					}
				});
			});
		}
	},
	/**
	 * @description: 关闭插屏页广告，客户端会调用此方法。
	 * @param {type}
	 * @return:
	 */

	addCloseFeedAdEvent(fun) {
		_initMethodList();
		onCloseFeedAdCallbacks.push(fun);
	},
	/**
	 * @description: 获取推啊自定义广告
	 * @param {type}
	 * @return:
	 */

	addShowTuiaCustomEvent(fun) {
		_initMethodList();
		onShowTuiaCustomCallbacks.push(fun);
	},
	/**
	 * @description: 接收一键登录的回掉
	 * @param {type}
	 * @return:
	 */

	addOneKeyLoginEvent(fun) {
		_initMethodList();
		onOneKeyLoginCallbacks.push(fun);
	},
	/**
	 * @description: 接收全屏信息流点击按钮的方法
	 * @param {type}
	 * @return:
	 */

	addBindWeChatAccountEvent(fun) {
		_initMethodList();
		onBindWeChatAccountCallbacks.push(fun);
		if (platform.platform == 'ios') {
			dsBridge.register('onBindWeChatAccount', function (res) {
				onBindWeChatAccountCallbacks.map((fun) => {
					try {
						fun(res);
					} catch (e) {
						console.log(e);
					}
				});
			});
		}
	},
	/**
	 * @description: 接收全屏信息流点击按钮的方法
	 * @param {type}
	 * @return:
	 */

	addFeedBtnClickEvent(fun) {
		_initMethodList();
		onFeedBtnClickCallbacks.push(fun);
	},
	/**
	 * @description: 接收全屏信息流副点击按钮的方法
	 * @param {type}
	 * @return:
	 */

	addFeedSubBtnClickEvent(fun) {
		_initMethodList();
		onFeedSubBtnClickCallbacks.push(fun);
	},
	/**
	 * @description: 监测是否在播放音乐
	 * @param {}
	 * @return:viod
	 */

	isMusicPlaying() {
		if (platform.platform === 'android') {
			return window.bridge.isMusicPlaying();
		}
	},
	/**
	 * @description: 关闭原生端音乐
	 * @param {}
	 * @return:viod
	 */

	pauseMusic() {
		if (window.bridge) {
			return window.bridge.pauseMusic();
		} else {
			console.log('没有桥能力');
			dsBridge.call('pauseMusic');
		}
	},
	/**
	 * @description: 播放原生端音乐
	 * @param {}
	 * @return:viod
	 */

	playMusic() {
		if (window.bridge) {
			return window.bridge.playMusic();
		} else {
			console.log('没有桥能力');
		}
	},
	/**
	 * @description: 获取签名方法
	 * @param {type}
	 * @return:
	 */

	getSignature(str) {
		if (platform.platform === 'ios') {
			return dsBridge.call('signContent', JSON.stringify(str));
		}
		if (window.bridge) {
			return window.bridge.signContent(str);
		}
	},

	addCalendarEvent(func) {
		onCalendarCallBacks = [];
		_initMethodList();
		onCalendarCallBacks.push(func);
		dsBridge.register('onCalendarCallBack', function (response) {
			onCalendarCallBacks.map((fun) => {
				try {
					fun(response);
				} catch (e) {
					console.log(e);
				}
			});
		});
	},
	/**
	 * @description: 打开客户端路由页面
	 * @param {type}
	 * @return:
	 */

	openNativePage(url) {
		if (platform.platform === 'ios') {
			return dsBridge.call('openNativePage', url);
		}
		if (window.bridge && window.bridge.openNativePage) {
			window.bridge.openNativePage(url);
		}
	},
	/**
	 * @description: 打开日历通知权限页面
	 * @param {type}
	 * @return:
	 */

	launchAppDetailsSettings() {
		if (window.bridge && window.bridge.launchAppDetailsSettings) {
			window.bridge.launchAppDetailsSettings();
		} else {
			dsBridge.call('launchAppDetailsSettings');
		}
	},
	/**
	 * @description: 友盟埋点方法
	 * @param {type}
	 * @return:
	 */

	umengTrack(eName, eData) {
		if (window.bridge && window.bridge.UTrack) {
			console.log(`eName => ${eName}`);
			console.log(`eData => ${eData}`);
			window.bridge.UTrack(eName, eData);
		}
	},

	/**
	 * @description: 判断话题页的歌曲是不是正在播放
	 * @return {type}
	 */

	isTopicMusicPlaying() {
		if (window.bridge && window.bridge.isPlaying) {
			return window.bridge.isPlaying();
		}
	},

	/**
	 * @description: 打开插屏页测试
	 * @param {string} adId - 代码位ID
	 * @param {string} adSource - 代码位类型，ocean_engine or gdt
	 * @param {string} mode - 横屏 or 竖屏
	 * @return: void
	 */

	loadInteractionAd(adId, adSource, mode) {
		console.log(`adId => ${adId}`);
		console.log(`adSource => ${adSource}`);
		console.log(`extra => ${mode}`);

		const params = {
			adId,
			adSource,
			extra: {
				mode,
			},
		};

		if (window.bridge && window.bridge.loadInteractionAd) {
			window.bridge.loadInteractionAd(JSON.stringify(params));
		}
	},

	/**
	 * @description: 增加投稿上传成功的监听
	 * param {function} func - 回调函数
	 */
	addUploadSuccessEvent(func) {
		onUploadSuccessCallBacks = [];
		_initMethodList();
		onUploadSuccessCallBacks.push(func);
	},

	/**
	 * @description: 注册监听客户端控制音乐的方法
	 * @return {void}
	 */
	setPlayStatusListener() {
		if (window.bridge) {
			window.bridge.setPlayStatusListener();
		}
	},

	/**
	 * @description: 加载信息流广告
	 * @param {string} adId - 广告位ID
	 * @return {void}
	 */
	loadTTFeed(adId) {
		if (window.bridge && window.bridge.loadTTFeed) {
			window.bridge.loadTTFeed(adId);
		}
		if (platform.platform === 'ios') {
			dsBridge.call('loadTTFeed', adId);
		}
	},

	/**
	 * @description: 关闭信息流广告
	 * @return {void}
	 */
	closeTTFeed() {
		if (window.bridge && window.bridge.closeTTFeed) {
			window.bridge.closeTTFeed();
		}
		if (platform.platform === 'ios') {
			dsBridge.call('closeTTFeed');
		}
	},

	/**
	 * @description: 支付宝认证成功回调
	 * @return void
	 */

	alipaySuccess() {
		if (platform.platform === 'ios') {
			dsBridge.call('zfbBridgeSuccess');
		} else if (window.zfbBridge && window.zfbBridge.success) {
			window.zfbBridge.success();
		}
	},
};
// ========================================= 导出客户端的方法供 H5 端调用 =========================================



// WEBPACK FOOTER //
// ./src/lib/sdk.js